import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-followup-date-edit',
  templateUrl: './modal-followup-date-edit.component.html',
  styles: []
})
export class ModalFollowupDateEditComponent extends ExcTranslation implements OnInit {

  followupDate: any = null;
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
  }

  ngOnInit() {
    this.followupDate = this.overlayConfig.data.FollowupDate;
  }
  hasChanges() {
    return true;
  }
  proceed() {
    this.overlayRef.close({proceed: true, FollowupDate: this.followupDate});
  }

}
